








import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class TeamInfo extends Vue {
  @Prop() private currentTeam!: any;
  @Prop() private currentTeamUsers!: any[];

  get membersText() {
    if (this.currentTeamUsers) {
      let len = this.currentTeamUsers.length;
      if (len === 1) {
        return `${len} member`;
      }
      return `${len} members`;
    }
  }
}
